// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.config-admin {
  width: min(96vw, 900px);
  max-height: 84vh;
  background: #1c2c40;
  border: 1px solid #4a9eff;
  border-radius: 10px;
  box-shadow: 0 8px 40px rgba(0, 0, 0, 0.55);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.config-admin__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding: 1.1rem 1.3rem;
  border-bottom: 1px solid rgba(74, 158, 255, 0.2);
}

.config-admin__title {
  margin: 0;
  color: #fff;
  font-size: 1.2rem;
}

.config-admin__close {
  background: none;
  border: none;
  color: #9fb4cc;
  font-size: 1rem;
  cursor: pointer;
  line-height: 1;
  padding: 0.3rem;
  border-radius: 6px;
  transition: background 0.2s, color 0.2s;
}

.config-admin__close .icon { width: 1.1rem; height: 1.1rem; }

.config-admin__close:hover {
  background: #23384f;
  color: #fff;
}

.config-admin__body {
  padding: 1.1rem 1.3rem;
  overflow-y: auto;
  color: #cdd8e6;
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.25) transparent;
}

.config-admin__body::-webkit-scrollbar { width: 8px; }
.config-admin__body::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.25);
  border-radius: 4px;
}

.config-admin__hint {
  margin: 0 0 0.9rem;
  font-size: 0.85rem;
  color: #9fb4cc;
}

.config-admin__toolbar {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 0.9rem;
  flex-wrap: wrap;
}

.config-admin__search {
  flex: 1 1 240px;
  min-width: 160px;
  padding: 0.45rem 0.7rem;
  background: #16233450;
  border: 1px solid rgba(74, 158, 255, 0.3);
  border-radius: 6px;
  color: #eef4fb;
  font-size: 0.85rem;
}

.config-admin__search:focus {
  outline: none;
  border-color: #4a9eff;
}

.config-admin__count {
  font-size: 0.8rem;
  color: #9fb4cc;
  white-space: nowrap;
}

.config-admin__error {
  margin-bottom: 0.9rem;
  padding: 0.6rem 0.8rem;
  border-radius: 6px;
  background: rgba(255, 90, 90, 0.12);
  border: 1px solid rgba(255, 90, 90, 0.4);
  color: #ffb3b3;
  font-size: 0.85rem;
}

.config-admin__status {
  padding: 1rem 0;
  color: #9fb4cc;
  font-size: 0.9rem;
}

.config-admin__table-wrap {
  overflow-x: auto;
}

.config-admin__table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.82rem;
}

.config-admin__table th,
.config-admin__table td {
  text-align: left;
  padding: 0.5rem 0.7rem;
  border-bottom: 1px solid rgba(74, 158, 255, 0.12);
  vertical-align: top;
}

.config-admin__table th {
  color: #9fb4cc;
  font-weight: 600;
  position: sticky;
  top: 0;
  background: #1c2c40;
}

.config-admin__key {
  color: #eef4fb;
  font-family: ui-monospace, "Cascadia Code", Consolas, monospace;
  word-break: break-all;
  white-space: normal;
  min-width: 320px;
}

.config-admin__value {
  color: #cdd8e6;
  font-family: ui-monospace, "Cascadia Code", Consolas, monospace;
  word-break: break-all;
}

.config-admin__value-text {
  display: inline;
}

.config-admin__reveal {
  margin-left: 0.5rem;
  padding: 0.1rem 0.5rem;
  background: #16233450;
  border: 1px solid rgba(74, 158, 255, 0.4);
  border-radius: 5px;
  color: #9fd0ff;
  font-size: 0.72rem;
  cursor: pointer;
  vertical-align: baseline;
  transition: background 0.2s, color 0.2s;
  float: right;
}

.config-admin__reveal:hover:not(:disabled) {
  background: #23384f;
  color: #eef4fb;
}

.config-admin__reveal:disabled {
  opacity: 0.6;
  cursor: default;
}
`, "",{"version":3,"sources":["webpack://./src/components/config-admin-panel/config-admin-panel.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,0CAA0C;EAC1C,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,sBAAsB;EACtB,gDAAgD;AAClD;;AAEA;EACE,SAAS;EACT,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA,6BAA6B,aAAa,EAAE,cAAc,EAAE;;AAE5D;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,sDAAsD;AACxD;;AAEA,yCAAyC,UAAU,EAAE;AACrD;EACE,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,qBAAqB;EACrB,yCAAyC;EACzC,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,kBAAkB;EAClB,mCAAmC;EACnC,wCAAwC;EACxC,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;;EAEE,gBAAgB;EAChB,sBAAsB;EACtB,iDAAiD;EACjD,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,MAAM;EACN,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,+DAA+D;EAC/D,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,+DAA+D;EAC/D,qBAAqB;AACvB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,qBAAqB;EACrB,yCAAyC;EACzC,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,wBAAwB;EACxB,uCAAuC;EACvC,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB","sourcesContent":[".config-admin {\r\n  width: min(96vw, 900px);\r\n  max-height: 84vh;\r\n  background: #1c2c40;\r\n  border: 1px solid #4a9eff;\r\n  border-radius: 10px;\r\n  box-shadow: 0 8px 40px rgba(0, 0, 0, 0.55);\r\n  display: flex;\r\n  flex-direction: column;\r\n  overflow: hidden;\r\n}\r\n\r\n.config-admin__header {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 1rem;\r\n  padding: 1.1rem 1.3rem;\r\n  border-bottom: 1px solid rgba(74, 158, 255, 0.2);\r\n}\r\n\r\n.config-admin__title {\r\n  margin: 0;\r\n  color: #fff;\r\n  font-size: 1.2rem;\r\n}\r\n\r\n.config-admin__close {\r\n  background: none;\r\n  border: none;\r\n  color: #9fb4cc;\r\n  font-size: 1rem;\r\n  cursor: pointer;\r\n  line-height: 1;\r\n  padding: 0.3rem;\r\n  border-radius: 6px;\r\n  transition: background 0.2s, color 0.2s;\r\n}\r\n\r\n.config-admin__close .icon { width: 1.1rem; height: 1.1rem; }\r\n\r\n.config-admin__close:hover {\r\n  background: #23384f;\r\n  color: #fff;\r\n}\r\n\r\n.config-admin__body {\r\n  padding: 1.1rem 1.3rem;\r\n  overflow-y: auto;\r\n  color: #cdd8e6;\r\n  scrollbar-width: thin;\r\n  scrollbar-color: rgba(255, 255, 255, 0.25) transparent;\r\n}\r\n\r\n.config-admin__body::-webkit-scrollbar { width: 8px; }\r\n.config-admin__body::-webkit-scrollbar-thumb {\r\n  background: rgba(255, 255, 255, 0.25);\r\n  border-radius: 4px;\r\n}\r\n\r\n.config-admin__hint {\r\n  margin: 0 0 0.9rem;\r\n  font-size: 0.85rem;\r\n  color: #9fb4cc;\r\n}\r\n\r\n.config-admin__toolbar {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.75rem;\r\n  margin-bottom: 0.9rem;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.config-admin__search {\r\n  flex: 1 1 240px;\r\n  min-width: 160px;\r\n  padding: 0.45rem 0.7rem;\r\n  background: #16233450;\r\n  border: 1px solid rgba(74, 158, 255, 0.3);\r\n  border-radius: 6px;\r\n  color: #eef4fb;\r\n  font-size: 0.85rem;\r\n}\r\n\r\n.config-admin__search:focus {\r\n  outline: none;\r\n  border-color: #4a9eff;\r\n}\r\n\r\n.config-admin__count {\r\n  font-size: 0.8rem;\r\n  color: #9fb4cc;\r\n  white-space: nowrap;\r\n}\r\n\r\n.config-admin__error {\r\n  margin-bottom: 0.9rem;\r\n  padding: 0.6rem 0.8rem;\r\n  border-radius: 6px;\r\n  background: rgba(255, 90, 90, 0.12);\r\n  border: 1px solid rgba(255, 90, 90, 0.4);\r\n  color: #ffb3b3;\r\n  font-size: 0.85rem;\r\n}\r\n\r\n.config-admin__status {\r\n  padding: 1rem 0;\r\n  color: #9fb4cc;\r\n  font-size: 0.9rem;\r\n}\r\n\r\n.config-admin__table-wrap {\r\n  overflow-x: auto;\r\n}\r\n\r\n.config-admin__table {\r\n  width: 100%;\r\n  border-collapse: collapse;\r\n  font-size: 0.82rem;\r\n}\r\n\r\n.config-admin__table th,\r\n.config-admin__table td {\r\n  text-align: left;\r\n  padding: 0.5rem 0.7rem;\r\n  border-bottom: 1px solid rgba(74, 158, 255, 0.12);\r\n  vertical-align: top;\r\n}\r\n\r\n.config-admin__table th {\r\n  color: #9fb4cc;\r\n  font-weight: 600;\r\n  position: sticky;\r\n  top: 0;\r\n  background: #1c2c40;\r\n}\r\n\r\n.config-admin__key {\r\n  color: #eef4fb;\r\n  font-family: ui-monospace, \"Cascadia Code\", Consolas, monospace;\r\n  word-break: break-all;\r\n  white-space: normal;\r\n  min-width: 320px;\r\n}\r\n\r\n.config-admin__value {\r\n  color: #cdd8e6;\r\n  font-family: ui-monospace, \"Cascadia Code\", Consolas, monospace;\r\n  word-break: break-all;\r\n}\r\n\r\n.config-admin__value-text {\r\n  display: inline;\r\n}\r\n\r\n.config-admin__reveal {\r\n  margin-left: 0.5rem;\r\n  padding: 0.1rem 0.5rem;\r\n  background: #16233450;\r\n  border: 1px solid rgba(74, 158, 255, 0.4);\r\n  border-radius: 5px;\r\n  color: #9fd0ff;\r\n  font-size: 0.72rem;\r\n  cursor: pointer;\r\n  vertical-align: baseline;\r\n  transition: background 0.2s, color 0.2s;\r\n  float: right;\r\n}\r\n\r\n.config-admin__reveal:hover:not(:disabled) {\r\n  background: #23384f;\r\n  color: #eef4fb;\r\n}\r\n\r\n.config-admin__reveal:disabled {\r\n  opacity: 0.6;\r\n  cursor: default;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
